import {ValidationError} from "../ICustomForm";
import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import m, {Vnode} from "mithril";
import {CellItem} from "../../model/items/cellItem";
import {CheckboxItem} from "../../model/items/checkbox";
import GeneralCellFactory from "./GeneralCellFactory";

export default class General extends CustomForm  {
    private errorMessage: string|null = null;

    private readonly cells: {view: ()=>Vnode|null}[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const layout = settings.form.grid.layout;
        const factory = new GeneralCellFactory(settings, (ci, v) => this.onSetValue(ci, v));
        for (const row of layout) {
            const component = factory.fromRow(row);
            if (component) {
                this.cells.push(component);
            }
        }

    }


    checkRequirements(): boolean {
        return true;
    }

    public rewriteFormControls() {
        return true;
    }

    public onValidationErrors(errors: ValidationError[]): void {
        this.errorMessage = this.settings.app.messages.get('validateMessage');
    }


    public view(): Vnode {
        const inputs = this.cells.map(c => m(c));

        const videoView = this.viewHeroVideo();
        if (this.videoItem && videoView) {
            inputs.unshift(videoView);
        }

        return this.viewLayout(m("form", {}, inputs));
    };

}
